import { createSelector } from '@ngrx/store';

import { betslipSelector } from '../../base/store/selectors';

export const betslipPlaceButtonStateSelector = createSelector(betslipSelector, (state) => state.placeButton);
export const betslipPlaceButtonStateIsValidSelector = createSelector(betslipPlaceButtonStateSelector, (state) => state.isValid);
export const betslipBetInProgressStateSelector = createSelector(betslipSelector, (state) => state.placeBet.betInProgress);
export const betslipPreBetStatusSelector = createSelector(betslipSelector, (state) => state.placeBet.preBetStatus);
